var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-check",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12.911,
    viewBox: "0 0 18 12.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M17.472,58.219l-9.5,9.359a1.82,1.82,0,0,1-2.548,0l-4.9-4.832a1.758,1.758,0,0,1,0-2.511,1.82,1.82,0,0,1,2.547,0L6.7,63.812l8.221-8.1a1.82,1.82,0,0,1,2.548,0A1.758,1.758,0,0,1,17.472,58.219Z",
    transform: "translate(0 -55.188)",
    fill: "#0ecc00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic-check.d56deea5d5e5036cc580f8a73acbe9b8.svg";
export { ForwardRef as ReactComponent };